import { API } from 'src/api';
import useSWR from 'swr';
//To be deleted
export const useMembers = (workspaceId?: string) => {
  const { data: members, revalidate: revalidateMembers } = useSWR<{ data: { data: Member[] } }>(
    workspaceId ? `/user/members?workspace=${workspaceId}` : '/user/members',
    API.get
  );
  return { members, revalidateMembers };
};

export const useMembersT = (workspaceId?: string) => {
  const data = API.get(`/user/members?workspace=${workspaceId}`);
  return data;
};

export interface Member {
  activeWorkspace: string;
  audio_mode: string;
  avatar: string;
  availability?: { hours: number };
  role: string;
  createdAt: string;
  dateformat: string;
  defaultWorkspace: string;
  email: string;
  firstday: string;
  firstname: string;
  lastname: string;
  memberId: string;
  _id: string;
  notifications: {
    alerts: {
      collaboration_invite: boolean;
      creation_doc_shared: boolean;
      deadline_reminders: boolean;
      mentions: boolean;
    };
    email: {
      creation_invite: boolean;
      creation_unlocked: boolean;
      doc_invite: boolean;
      board_invite: boolean;
      organisation_invite: boolean;
      mention_creation: boolean;
      mention_document: boolean;
      mention_board: boolean;
      mention_lesson: boolean;
    };
    other_email: { new_features: boolean; recommended_modules: boolean; tips_n_tricks: boolean };
    onboarded: boolean;
    organisation: string;
    role: string;
    timezone: string;
    updatedAt: string;
    workspaces: string[];
    _id: string;
  };
}
